import { z } from 'zod';

import { gatewayTypeSchema } from './gatewayType';
import { gatewayPositionSchema, installationTaskDeviceTypeSchema } from './installationTask';
import { positionSchema, sensorTypeSchema } from './sensor';

export type InstallationTaskImportMode = z.infer<typeof installationTaskImportModeSchema>;
export const installationTaskImportModeSchema = z.enum(['ADD', 'REPLACE_MATCHING']);

export const installationTaskImportCoordinateSchema = z.object({
  x: z.number().int().nonnegative(),
  y: z.number().int().nonnegative(),
});
export const installationTaskImportItemSchema = z.object({
  itemId: z.string(),
  groupKey: z.string(),
  deviceType: installationTaskDeviceTypeSchema,
  position: z.union([positionSchema, gatewayPositionSchema]),
  sensorType: sensorTypeSchema.nullable(),
  gatewayType: gatewayTypeSchema.nullable(),
  coordinates: installationTaskImportCoordinateSchema,
  sourceName: z.string().nullable(),
  sourceObjectType: z.string().nullable(),
  sourceTag: z.string().nullable(),
});

export type InstallationTaskImportItem = z.infer<typeof installationTaskImportItemSchema>;
export const installationTaskImportGroupSchema = z.object({
  groupKey: z.string(),
  deviceType: installationTaskDeviceTypeSchema,
  position: z.union([positionSchema, gatewayPositionSchema]),
  sensorType: sensorTypeSchema.nullable(),
  gatewayType: gatewayTypeSchema.nullable(),
  count: z.number().int().nonnegative(),
  existingMatchingPlannedCount: z.number().int().nonnegative(),
  sourceObjectTypes: z.array(z.string()),
  sourceTags: z.array(z.string()),
});

export type InstallationTaskImportPreview = z.infer<typeof installationTaskImportPreviewSchema>;
export const installationTaskImportPreviewSchema = z.object({
  totalRows: z.number().int().nonnegative(),
  importableRows: z.number().int().nonnegative(),
  ignoredRows: z.number().int().nonnegative(),
  sensorCount: z.number().int().nonnegative(),
  gatewayCount: z.number().int().nonnegative(),
  items: z.array(installationTaskImportItemSchema),
  groups: z.array(installationTaskImportGroupSchema),
  warnings: z.array(z.string()),
});

export type InstallationTaskImportGroup = z.infer<typeof installationTaskImportGroupSchema>;
export const installationTaskImportPreviewResponseSchema = z.object({
  preview: installationTaskImportPreviewSchema,
});
export const installationTaskImportApplyResultSchema = z.object({
  rowsInserted: z.number().int().nonnegative(),
  rowsDeleted: z.number().int().nonnegative(),
  sensorCount: z.number().int().nonnegative(),
  gatewayCount: z.number().int().nonnegative(),
  warnings: z.array(z.string()),
});
export const installationTaskImportApplyResponseSchema = z.object({
  result: installationTaskImportApplyResultSchema,
});
